<template>
  <div class="filedsContainer">
    <div class="head">
      <div class="title">{{ typeName }}</div>
      <div class="font-tip">编辑{{ typeName }}字段信息</div>
    </div>
    <div class="body">
      <QDocument v-if="steps == 1" :documentList="documentList" />
      <QFields v-if="steps == 2" :filedsList="filedsList" />
    </div>
    <div class="footer">
      <el-button v-if="steps == 1" type="primary" size="mini" @click="nextStep"
        >下一步</el-button
      >
      <el-button v-if="steps == 2" type="primary" size="mini" @click="save"
        >保存</el-button
      >
      <el-button size="mini" @click="back">返回</el-button>
    </div>
  </div>
</template>
<script>
import QDocument from "../components/qDocument.vue";
import QFields from "../components/qFields.vue";

import {
  getListByTypeCode,
  queryByCertificateIds,
  saveCertify,
} from "@/api/qualification/qualification";
export default {
  name: "CustomerFields",
  components: {
    QDocument,
    QFields,
  },
  data() {
    return {
      steps: 1,
      typeName: "-",
      typeCode: "",
      documentList: [],
      filedsList: [],
    };
  },
  methods: {
    createParamsData() {
      let certifyList = [];
      const paramas = {
        typeCode: this.typeCode,
        typeName: this.typeName,
        shopCertificatesDTOS: this.documentList
          .filter((d) => d.selected)
          .map((doc) => {
            return {
              selected: doc.selected,
              name: doc.title,
              defaultExpire: doc.defaultPeriod,
              expire: String(doc.validityPeriodList),
              template: doc.template[0]?.url,
              example: doc.demo[0]?.url,
              description: doc.tipsText,
              required: doc.required,
              certificateId: doc.certificateId,
            };
          }),
        certify: [],
      };
      this.filedsList.forEach((f) => {
        certifyList = [...certifyList, ...f.list];
      });
      paramas.certify = certifyList.map((f) => {
        return {
          certifyId: f.certifyId,
          required: f.required,
          submit: f.submit,
          examine: f.examine,
          certifyName: f.filedsName,
        };
      });
      console.log(paramas, "paramas");
      return paramas;
    },
    save() {
      const data = this.createParamsData();
      saveCertify(data).then((res) => {
        this.$message.success("保存成功");
        this.$router.go(-1);
      });
    },
    nextStep() {
      this.steps = this.steps + 1;
      queryByCertificateIds({
        typeCode: this.typeCode,
        ids: this.documentList
          .filter((item) => item.selected)
          .map((item) => item.certificateId),
      }).then((res) => {
        this.filedsList = res.data.map((fileds) => {
          return {
            id: fileds.certificateId,
            title: fileds.certificateName,
            list: fileds.compCertifyConfigList.map((filed) => {
              return {
                filedsName: filed.certifyName,
                certifyId: filed.certifyId,
                submit: filed.submit || false,
                examine: filed.examine || false,
                required: filed.required || false,
              };
            }),
          };
        });
      });
    },
    back() {
      if (this.steps == 1) {
        this.$router.go(-1);
      } else {
        this.steps = 1;
      }
    },
  },
  mounted() {
    const { typeCode, typeName } = this.$route.query;
    this.typeName = typeName;
    this.typeCode = typeCode;
    typeCode &&
      getListByTypeCode({ typeCode }).then((res) => {
        this.documentList = res.data.map((item) => {
          return {
            selected: item.selected,
            title: item.name,
            certificateId: item.certificateId,
            required: item.required,
            tipsText: item.description,
            demo: item.example
              ? [{ name: item.example, url: item.example }]
              : [],
            template: item.template
              ? [{ name: item.template, url: item.template }]
              : [],
            validityPeriodList: String(item.expire).split(",") || [],
            defaultPeriod: Number(item.defaultExpire),
          };
        });
      });
  },
};
</script>
<style lang='scss' scoped>
.filedsContainer {
  display: flex;
  flex-flow: column;
  height: 100%;
  overflow-y: auto;
  .head {
    background: #ffffff;
    height: 76px;
    padding: 10px;
    line-height: 28px;
  }
  .font-tip {
    padding-left: 20px;
    font-size: 12px;
  }
  .body {
    background: #ffffff;
    padding: 10px;
    margin-top: 10px;
    display: flex;
    flex: 1;
    overflow-y: auto;
  }
  .footer {
    padding: 20px;
    background: #ffffff;
  }
}
</style>